export const UI_LANGUAGE_FIELD = "ui.languages.enabled";
export const UI_LANGUAGE_DEFAULT = "es|en";

export const UI_LANGUAGE_OPTIONS = [
  { code: "es", label: "Español" },
  { code: "en", label: "English" },
  { code: "fr", label: "Français" },
  { code: "de", label: "Deutsch" },
  { code: "it", label: "Italiano" },
  { code: "pt", label: "Português" },
  { code: "zh", label: "中文" },
];

const ALLOWED = new Set(UI_LANGUAGE_OPTIONS.map((item) => item.code));

export const parseEnabledLanguages = (value) => {
  const source = value == null || String(value).trim() === "" ? UI_LANGUAGE_DEFAULT : String(value);
  const unique = [];
  source.split("|").forEach((part) => {
    const code = part.trim().toLowerCase();
    if (ALLOWED.has(code) && !unique.includes(code)) {
      unique.push(code);
    }
  });
  return unique.length > 0 ? unique : ["es"];
};

export const enabledLanguageOptions = (value) => {
  const enabled = new Set(parseEnabledLanguages(value));
  return UI_LANGUAGE_OPTIONS.filter((item) => enabled.has(item.code));
};

export const activeLanguageCode = (language) => {
  const code = String(language || "es").slice(0, 2).toLowerCase();
  return ALLOWED.has(code) ? code : "es";
};
